import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { QUERY_EMPLOYEE_TAX_FORM_SCHEMA } from "../keys";
import { employeeTaxFormsService } from "../../../services/employeeTaxForms";
import { IGetFormSchemaResponse } from "../../../modules/EmployeeTaxForms/types";
import { WSServiceError } from "../../../utils/serviceHelper";

export const useQueryEmployeeTaxFormSchema = (
  formInstanceId: string,
  queryConfig?: WSQueryConfig<IGetFormSchemaResponse, WSServiceError>
) =>
  useWSQuery<IGetFormSchemaResponse, WSServiceError>(
    [QUERY_EMPLOYEE_TAX_FORM_SCHEMA, formInstanceId],
    () => employeeTaxFormsService.getSchema({ formInstanceId }),
    {
      enabled: !!formInstanceId,
      // The schema (revision/currentFiling) can change out-of-band (e.g. a
      // correction issued via the migration CLI); the app-wide
      // staleTime:Infinity would otherwise serve a stale revision all session.
      // Re-read on every mount.
      refetchOnMount: "always",
      staleTime: 0,
      ...queryConfig
    }
  );
